var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg067Bd928715F05207C3E1E92Af7605A7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "114px",
    height: "109px",
    viewBox: "0 0 114 109",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Star") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shape",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-Explenation",
    transform: "translate(-1416.000000, -590.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#617379",
    id: "Star",
    points: "1473 680 1437.73288 698.54102 1444.4683 659.27051 1415.93661 631.45898 1455.36644 625.72949 1473 590 1490.63356 625.72949 1530.06339 631.45898 1501.5317 659.27051 1508.26712 698.54102"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg067Bd928715F05207C3E1E92Af7605A7);
export default __webpack_public_path__ + "static/media/067bd928715f05207c3e1e92af7605a7.c1e836bc96a1d2a740aba3deeeb637c4.svg";
export { ForwardRef as ReactComponent };